<app-input-label [inputId]="id" [inputName]="name" [mandatory]="mandatory" [helpTooltipText]="helpTooltipText"
  [isClickable]="true"></app-input-label>

<div [id]="inputZoneId" class="input-zone" (dragover)="handleFileInputDragover()"
  (dragleave)="handleFileInputDragleave()" (drop)="handleFileInputDrop()">
  <input [id]="id" [name]="name" class="input" type="file" [(ngModel)]="value" (blur)="onTouched($event)"
    (input)="handleInput($event)" [accept]="accept">

  <ng-container *ngIf="!value">
    <div class="icon-container">
      <app-lucide-icon [iconName]="'arrow-down-to-line'" [size]="30"></app-lucide-icon>
    </div>

    <span class="text">Arraste o arquivo e solte nesta área ou selecione no seu computador</span>
  </ng-container>

  <ng-container *ngIf="value">
    <div class="icon-container">
      <app-lucide-icon [iconName]="'arrow-down-to-line'" [size]="30"></app-lucide-icon>
    </div>

    <span class="text">{{ fileName }}</span>
  </ng-container>
</div>